<template>
    <div v-if="type=='poster'" class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="imagebox-courses-type1">
            <div class="featured-post">
                <img src="/wwwroot/images/home1/tax-opague.jpg" alt="images" class="course-card">
            </div>
            <div class="author-info">
                <div class="avatar">
                    <img v-bind:src="course.author | s3url" style="width:65px; border-radius: 50px;">
                </div>
                <div class="category">
                    {{ course.name }}
                </div>
                <div class="name">
                    <router-link :to="{ name: 'CourseInfo', params: { id: course.id }}">Learn More ...</router-link>
                </div>
                <div class="add-cart">
                    <router-link class="add-cart-a" v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">Continue</router-link>
                    <button v-else class="add-cart-a" v-on:click="addToCart">{{ course.price > 0 ? "Add to cart" : "Enrol" }}</button>
                </div>
                <div class="border-bt">

                </div>
                <div class="evaluate">
                    <div class="price">
                        <span class="price-now">R {{ course.price }}</span>
                    </div>
                    <div class="review">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <span>(4)</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="type == 'card' || type == null" class="flat-course clearfix row">

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="featured-post">
                <div class="entry-image">
                    <img v-bind:src="course | s3url" alt="images" style="width: 370px; height: 270px; border: 2px solid #3d3c79; border-radius: 10px;">
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="course-content clearfix">
                <div class="wrap-course-content">
                    <h4>
                        <router-link v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">{{ course.name }}</router-link>
                        <router-link v-else :to="{ name: 'CourseInfo', params: { id: course.id }}">{{ course.name }}</router-link>
                    </h4>
                    <p>
                        {{ course.descriptionShort }}
                    </p>
                    <div class="author-info">
                        <div v-if="course.author" class="author-name">
                            {{ course.author.firstName }} {{ course.author.lastName }}
                        </div>
                        <div class="enroll">
                            <router-link v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">Continue</router-link>
                            <button v-else v-on:click="addToCart">{{ course.price > 0 ? "Add to cart" : "Enrol" }}</button>
                        </div>
                    </div>
                </div>
                <div v-if="!course.userAssigned" class="wrap-rating-price">
                    <div class="meta-rate">
                        <div class="rating">
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <span>(4)</span>
                        </div>
                        <div class="price">
                            <span class="price-previou">

                            </span>
                            <span v-if="course.priceUsd" class="price-now">R {{ course.price }} / $ {{ course.priceUsd }}</span>
                            <span v-else class="price-now">R {{ course.price }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .enroll a {
        display: inline-block;
        padding: 10px 28px;
        line-height: 24px;
        font-size: 14px;
        text-transform: uppercase;
        color: #ffffff;
        background: #3d3c79;
        border: 2px solid #3d3c79;
        -webkit-border-radius: 2px;
    }

</style>
<script>
    export default {
        name: 'CourseCardComponent',
        props: {
            course: Object,
            type: String
        },
        methods: {
            addToCart() {
                this.$store.commit("addToCart", {
                    type: "course",
                    id: this.course.id,
                    name: this.course.name,
                    price: this.course.price,
                    priceUsd: this.course.priceUsd,
                    imageFileName: this.course.imageFileName
                });
            }
        },
        computed: {

        }
    }
</script>

<style scoped>
</style>